<template>
    <CDropdown>
        <CDropdownToggle
            :id="id"
            :color="color"
            :caret="caret"
            :disabled="disabled"
            class="d-dropdown-toggle"
        >
            <DIcon
                v-if="icon"
                :size="20"
                :name="icon"
            />
            {{ togglerText }}
        </CDropdownToggle>
        <CDropdownMenu :id="dropdownId">
            <slot />
        </CDropdownMenu>
    </CDropdown>
</template>

<script>
import { CDropdown, CDropdownToggle, CDropdownMenu } from '@coreui/vue-pro'

export default {
    name: 'DRow',
    components: { CDropdownToggle, CDropdown, CDropdownMenu },
    props: {
        togglerText: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: 'secondary'
        },
        icon: {
            type: String,
            default: null
        },
        caret: {
            type: Boolean,
            default: true
        },
        id: {
            type: String,
            default: null
        },
        dropdownId: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style>
.dropdown-toggle {
    box-shadow: none !important;
}

.d-dropdown-toggle {
    border-radius: 0.375rem !important;
}
</style>
